import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-560edaca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-2 w-full rounded-full relative bg-gray-300 dark:bg-dark-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`progress-bar-color h-full rounded-full absolute top-0 left-0 ${
        _ctx.colorType === 'COURSE' ? 'bg-course dark:bg-course-dark' : 'bg-challenge'
      }`),
      style: _normalizeStyle(`--bar-width: ${_ctx.num};`)
    }, null, 6)
  ]))
}